module.exports = __webpack_public_path__ + "static/media/img37.33d9fc45.jpg";